import { Product } from './product';
import { RecipeComponentPortion } from './dish';
import { ComponentType, UnitOfMeasure } from './enums';
import { Supplier, SupplierType } from './supplier';

export enum IngredientAttributeEnum {
  Categories = 'categories',
  Flavors = 'flavors',
  Dietary = 'dietary',
  Allergens = 'allergens',
  Storage = 'storage',
  Seasonality = 'seasonality',
}

type Ingredient = {
  componentId: string;
  componentName: string;
  name?: string;
}

export type IngredientForDish = (Ingredient) & {
  componentName: string;
};

export type IngredientInRecipe = IngredientForDish & {
  portions: RecipeComponentPortion[];
};

export type IngredientCost = {
  ingredientId: number;
  weight: number;
  cost: number;
  authorId: string | null;
  updatedAt: string;
};

export type NewProductToComponents = {
  id: number,
  productId: number,
  componentId: number,
  authorId: string,
  isActive: boolean,
  quantity: number,
  unit: UnitOfMeasure,
}

export type NewProductToIngredientsWithProduct = (NewProductToComponents & { product: Product })

export type IngredientWithProductToIngredients = Component
  & {
    productToComponents: NewProductToIngredientsWithProduct[]
  }

export type IngredientWithProducts = Ingredient & {
  id: number;
  productToComponents?: {
    quantity: number
    product: Product;
  }[];
}

export type UpdateIngredientCost = {
  ingredientId: number,
  weight: number,
  cost: number,
}

export type Component = {
  id: string;
  name: string;
  type: string;
  authorId: string | null
}

export type IngredientWithProductsRecipesAttributes = {
  id: string;
  name: string;
  type: ComponentType;
  authorId: string | null;
  products: {
    id: number;
    authorId: string | null;
    isActive: boolean;
    quantity: number;
    name: string;
    displayRatio: string;
    price: number;
    source: string;
    updatedAt: Date;
  }[];
  recipeIds: string[];
  attributes: {
    id: number;
    name: string;
    type: string;
  }[];
};

export type MappedIngredient = {
  id: string;
  name: string;
  type: ComponentType;
  products: {
    id: number;
    isActive: boolean;
    quantity: number;
    unit: UnitOfMeasure;
    name: string;
    displayRatio: string;
    price: number;
    description: string | null;
    updatedAt: Date;
    supplier: {
      id: number;
      name: string;
      managedById: string | null;
      type: SupplierType;
      info?: string | null;
    }
  }[];
  recipes: {
    id: string;
    dish: {
      id: string;
      title: string;
      type: ComponentType
    }
  }[];
  attributes: {
    id: number;
    name: string;
    type: string;
  }[];
};

export type IngredientWithProduct = {
  id: number;
  productId: number;
  componentId: string;
  authorId: string;
  isActive: boolean;
  quantity: number;
  unit: UnitOfMeasure;
  product: {
    id: number;
    name: string;
    displayRatio: string;
    price: number;
    source: string;
    description: string | null;
    authorId: string | null;
    supplierId: number;
    updatedAt: string;
    supplier: Supplier;
  }
}
